import _toConsumableArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import calcAge from "@/lib/calcAge";
import config from "@/lib/config";
import { errorMessages, GENDER, metaSchemas, userRating } from "@/lib/constants";
import dayjs from "@/lib/day";
import { AUTH_ERROR_MESSAGES } from "@/lib/errors";
import getRemoteIpAddress from "@/lib/getRemoteIpAddress";
import { accountEditDuplicateAddress, accountEditPincodeMail, duplicateAddress, myskpWithdrawalComplete, passwordResetComplete, passwordResetTokenMail, passwordUpdateComplete, profilePinResetTokenMail, registerPincodeMail, signupComplete, userUpdate, withdrawalComplete } from "@/lib/mailTemplate";
import { isEnded } from "@/lib/metaUtil";
import PasswordToken from "@/lib/passwordToken";
import PINCode from "@/lib/pinCode";
import Rememberme from "@/lib/rememberme";
import sendEmail from "@/lib/sendEmail";
import UserToken from "@/lib/userToken";
import { gql } from "@apollo/client";
import { composeResolvers } from "@graphql-tools/resolvers-composition";
import { UserInputError } from "apollo-server-errors";
import crypto from "crypto";
import { createPageInfo, createToken, isAuthenticated, ownerOnly, metaResolveType, sleep, values, logicaErrorCode } from "./helper";
import { passwordFormatValidate } from "@/lib/yupPasswordValidate";
import Uid2Token from "@/lib/uid2Token";

function passwordValidate(password) {
  return password && password.length >= 8 && passwordFormatValidate(password);
}

export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  interface User {\n    uuid: ID!\n    id: Int\n    display_name: String\n    birthday: String\n    sex: Int\n    type: String\n  }\n\n  type AccountUser implements User @cacheControl(scope: PRIVATE, maxAge: 0) {\n    uuid: ID!\n    id: Int\n    display_name: String\n    birthday: String\n    age: Int\n    sex: Int\n    type: String\n    mail_address: String\n    first_name: String\n    last_name: String\n    fullName: String\n    rights_free_flag: Boolean\n    currentProfile: ProfileUser\n    profiles: [ProfileUser]\n    test_flg: Boolean\n    mySkpRelation: Boolean\n    mySkpEmail: String\n    hashedUserId: String\n  }\n\n  union FavoriteMeta = EpisodeMeta | LiveMeta | TVShowMeta | ChannelMeta\n\n  type UserFavorites @cacheControl(maxAge: 0) {\n    id: Int\n    metas: [FavoriteMeta]\n  }\n\n  type ProfileUser implements User @cacheControl(scope: PRIVATE, maxAge: 0) {\n    uuid: ID!\n    id: Int\n    display_name: String\n    birthday: String\n    age: Int\n    sex: Int\n    type: String\n    passcode: String\n    ownerProfile: Boolean\n    needPasscode: Boolean\n    icon: Int\n    rating: Int\n  }\n\n  type Auth {\n    token: String!\n    user: AccountUser\n  }\n\n  type UserUpdate {\n    user: AccountUser\n    error: String\n  }\n\n  type Profile @cacheControl(scope: PRIVATE, maxAge: 0) {\n    profile: ProfileUser\n  }\n\n  type AuthResult {\n    result: Boolean\n  }\n\n  type UserConnection {\n    user: AccountUser\n    profiles: [ProfileUser]\n  }\n\n  type PinCodeResult {\n    result: Boolean\n  }\n\n  type VerifyResult {\n    verified: Boolean\n    error: String\n  }\n\n  type FavoriteResult @cacheControl(maxAge: 0) {\n    result: Boolean\n    favorites: UserFavorites\n  }\n\n  type FavoritesByContentTypeResult @cacheControl(maxAge: 0) {\n    data: [FavoriteMeta]\n    pageInfo: PageInfo\n  }\n\n  type ViewingHistoriesResult @cacheControl(scope: PRIVATE, maxAge: 0) {\n    data: [MediaMeta]\n    pageInfo: PageInfo\n  }\n\n  type AddResumeResult {\n    result: Boolean\n  }\n\n  type UserDeleteResponse @cacheControl(scope: PRIVATE) {\n    result: Boolean\n  }\n  type AuthOwnerProfileResponse @cacheControl(scope: PRIVATE) {\n    result: Boolean\n  }\n\n  type DeleteProfileResponse @cacheControl(scope: PRIVATE) {\n    result: Boolean\n  }\n\n  type DeleteViewingHistoryResult @cacheControl(scope: PRIVATE, maxAge: 0) {\n    result: Boolean\n  }\n\n  type BroadcastDiscountResult @cacheControl(scope: PRIVATE, maxAge: 0) {\n    result: Boolean\n    user_voucher_id: Int\n  }\n\n  type Query {\n    user: AccountUser\n\n    userFavorites: UserFavorites\n\n    favoritesByContentType(\n      type: String\n      offset: Int\n      limit: Int\n    ): FavoritesByContentTypeResult\n\n    viewingHistories(\n      offset: Int\n      limit: Int\n      sort: String\n      nocache: Boolean\n    ): ViewingHistoriesResult\n\n    broadcastDiscount(courseId: Int, productId: Int): BroadcastDiscountResult\n  }\n\n  type Mutation {\n    login(\n      loginid: String!\n      password: String!\n      rememberme: Boolean\n      signature: String!\n    ): Auth\n\n    logout(force: Boolean): AuthResult\n\n    selectProfile(profileId: Int, passcode: String, type: String): AccountUser\n\n    signupPincode(mailAddress: String!): PinCodeResult\n\n    sendPincode(mailAddress: String!): PinCodeResult\n\n    sendProfilePinResetToken: PinCodeResult\n\n    sendPasswordResetToken(mailAddress: String!): PinCodeResult\n\n    verifyPinCode(code: String!, mailAddress: String!): VerifyResult\n\n    verifyPasswordToken(token: String!): VerifyResult\n\n    signup(\n      code: String!\n      mailAddress: String!\n      password: String!\n      firstName: String!\n      lastName: String!\n      birthday: String!\n      sex: String!\n      terms: String!\n      signature: String!\n    ): Auth\n\n    addFavorite(id: Int!): FavoriteResult\n\n    deleteFavorite(id: Int!): FavoriteResult\n\n    addResume(\n      resume: Int\n      metaId: Int\n      groupedMetaId: Int\n      psid: String\n      reachToEnd: Boolean\n    ): AddResumeResult\n\n    update(mailAddress: String, code: String): UserUpdate\n\n    updatePassword(currentPassword: String, password: String): UserUpdate\n\n    updateOwnerProfile(\n      displayName: String\n      icon: Int\n      passcode: String\n      rating: Int\n    ): UserUpdate\n\n    passwordReset(password: String!, token: String!): PinCodeResult\n\n    passcodeReset(passcode: String!, token: String!): PinCodeResult\n\n    addProfile(\n      displayName: String\n      birthday: String\n      sex: String\n      icon: Int\n      rating: Int\n      passcode: String\n    ): Profile\n\n    updateProfile(\n      displayName: String\n      birthday: String\n      sex: String\n      password: String\n      profileId: Int\n      icon: Int\n      rating: Int\n      passcode: String\n    ): Profile\n\n    deleteProfile(profileId: Int): DeleteProfileResponse\n\n    userDelete: UserDeleteResponse\n\n    authProfile(profileId: Int, passcode: String): AuthOwnerProfileResponse\n\n    deleteViewingHistory(metaIds: [String]): DeleteViewingHistoryResult\n  }\n"])));

function getProfiles(_x, _x2, _x3) {
  return _getProfiles.apply(this, arguments);
}

function _getProfiles() {
  _getProfiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(parent, dataSources, adultMode) {
    var profiles;
    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            _context34.next = 2;
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
              var res, profileIds;
              return _regeneratorRuntime.wrap(function _callee33$(_context33) {
                while (1) {
                  switch (_context33.prev = _context33.next) {
                    case 0:
                      if (parent !== null && parent !== void 0 && parent.profiles) {
                        _context33.next = 7;
                        break;
                      }

                      _context33.next = 3;
                      return dataSources.user.me();

                    case 3:
                      res = _context33.sent;
                      return _context33.abrupt("return", [res.user].concat(_toConsumableArray(res === null || res === void 0 ? void 0 : res.profiles)));

                    case 7:
                      profileIds = parent.profiles.map(function (p) {
                        return p.id;
                      });

                      if (!profileIds.includes(parent.id)) {
                        _context33.next = 12;
                        break;
                      }

                      return _context33.abrupt("return", _toConsumableArray(parent.profiles));

                    case 12:
                      return _context33.abrupt("return", [parent].concat(_toConsumableArray(parent.profiles)));

                    case 13:
                    case "end":
                      return _context33.stop();
                  }
                }
              }, _callee33);
            }))();

          case 2:
            profiles = _context34.sent;

            if (!adultMode) {
              _context34.next = 7;
              break;
            }

            return _context34.abrupt("return", [profiles[0]]);

          case 7:
            return _context34.abrupt("return", profiles);

          case 8:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34);
  }));
  return _getProfiles.apply(this, arguments);
}

function getFavoriteMetas(dataSources) {
  try {
    var res = dataSources.user.allFavorites({
      offset: 0,
      limit: 50
    });
    return res;
  } catch (e) {
    console.log("getFavoriteMetas", e);
    return null;
  }
}

function deleteToken(_x4, _x5) {
  return _deleteToken.apply(this, arguments);
}

function _deleteToken() {
  _deleteToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(req, res) {
    var userToken, uid2;
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            userToken = new UserToken(req, res);
            _context35.next = 3;
            return userToken.delete();

          case 3:
            uid2 = new Uid2Token(req, res);
            uid2.delete();
            req.userToken = null; // const _rememberme = new Rememberme();
            // _rememberme.delete(req.userToken.id);

          case 6:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35);
  }));
  return _deleteToken.apply(this, arguments);
}

export var resolvers = composeResolvers({
  Query: {
    user: function () {
      var _user = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _args, _ref) {
        var req, res, dataSources, result, _user2, _user2$values, userToken;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                req = _ref.req, res = _ref.res, dataSources = _ref.dataSources;

                if (!req.userToken) {
                  _context.next = 21;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return dataSources.user.me();

              case 5:
                result = _context.sent;
                _user2 = result.user;
                _user2.profiles = result.profiles; // hashedUserIdがなかったらユーザートークンを更新する
                // レコメンド対応で必要だが、リリース時にログインしていたユーザーのuserTokenからは取得できないため

                if (req.userToken.hashedUserId) {
                  _context.next = 12;
                  break;
                }

                userToken = new UserToken(req, res);
                _context.next = 12;
                return userToken.refresh({
                  hashedUserId: _user2 === null || _user2 === void 0 ? void 0 : (_user2$values = _user2.values) === null || _user2$values === void 0 ? void 0 : _user2$values.user_id_hash
                });

              case 12:
                return _context.abrupt("return", _user2);

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](2);
                console.log(_context.t0);
                _context.next = 20;
                return deleteToken(req, res);

              case 20:
                return _context.abrupt("return", null);

              case 21:
                return _context.abrupt("return", null);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 15]]);
      }));

      function user(_x6, _x7, _x8) {
        return _user.apply(this, arguments);
      }

      return user;
    }(),
    userFavorites: function () {
      var _userFavorites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _args, _ref2) {
        var req, dataSources, favoriteMetas, id;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                req = _ref2.req, dataSources = _ref2.dataSources;

                if (!req.userToken) {
                  _context2.next = 13;
                  break;
                }

                _context2.prev = 2;
                _context2.next = 5;
                return getFavoriteMetas(dataSources);

              case 5:
                favoriteMetas = _context2.sent;
                id = req.userToken.currentProfile || req.userToken.id;
                return _context2.abrupt("return", {
                  id: id,
                  metas: favoriteMetas
                });

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);
                return _context2.abrupt("return", {
                  metas: []
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 10]]);
      }));

      function userFavorites(_x9, _x10, _x11) {
        return _userFavorites.apply(this, arguments);
      }

      return userFavorites;
    }(),
    // お気に入り取得
    favoritesByContentType: function () {
      var _favoritesByContentType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_parent, args, _ref3) {
        var req, dataSources, type, offset, limit, metaSchemaId, dataLimit, res, favoriteMetas, now, deliveryDateFilter, totalCount;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                req = _ref3.req, dataSources = _ref3.dataSources;
                type = args.type, offset = args.offset, limit = args.limit;

                metaSchemaId = function () {
                  if (type === "channel") {
                    return metaSchemas.channel.id;
                  } else if (type === "tvshow") {
                    return metaSchemas.tvshow.id;
                  } else {
                    return metaSchemas.episode.id;
                  }
                }();

                dataLimit = 200;
                _context3.next = 6;
                return dataSources.user.favoritesByMetaSchemaId({
                  offset: 0,
                  limit: dataLimit,
                  metaSchemaId: metaSchemaId
                });

              case 6:
                res = _context3.sent;
                favoriteMetas = res.user_favorites.map(function (fav) {
                  return fav.meta;
                }).filter(function (meta) {
                  return !!meta;
                });
                now = dayjs();

                deliveryDateFilter = function deliveryDateFilter(meta) {
                  if (meta.delivery_end_at) {
                    return now.isBefore(meta.delivery_end_at);
                  }

                  return true;
                };

                if (type === "vod") {
                  favoriteMetas = favoriteMetas.filter(function (meta) {
                    var _meta$values;

                    return !(meta !== null && meta !== void 0 && (_meta$values = meta.values) !== null && _meta$values !== void 0 && _meta$values.is_live);
                  }).filter(deliveryDateFilter);
                } else if (type === "catchup") {
                  favoriteMetas = favoriteMetas.filter(function (meta) {
                    var _meta$values2, _meta$values3, _meta$values4;

                    if (!(meta !== null && meta !== void 0 && (_meta$values2 = meta.values) !== null && _meta$values2 !== void 0 && _meta$values2.is_live)) return false;
                    if (!(meta !== null && meta !== void 0 && (_meta$values3 = meta.values) !== null && _meta$values3 !== void 0 && _meta$values3.catch_up_flag)) return false;
                    var encodeEnded = isEnded(meta === null || meta === void 0 ? void 0 : (_meta$values4 = meta.values) === null || _meta$values4 === void 0 ? void 0 : _meta$values4.encode_end_date);
                    if (!encodeEnded) return false;
                    var deliveryEnded = isEnded(meta === null || meta === void 0 ? void 0 : meta.delivery_end_at);
                    if (deliveryEnded) return false;
                    return true;
                  }).filter(deliveryDateFilter);
                } else if (type === "live") {
                  favoriteMetas = favoriteMetas.filter(function (meta) {
                    var _meta$values5, _meta$values6;

                    if (!(meta !== null && meta !== void 0 && (_meta$values5 = meta.values) !== null && _meta$values5 !== void 0 && _meta$values5.is_live)) {
                      return false;
                    }

                    var ended = isEnded(meta === null || meta === void 0 ? void 0 : (_meta$values6 = meta.values) === null || _meta$values6 === void 0 ? void 0 : _meta$values6.encode_end_date);
                    return !ended;
                  }).filter(deliveryDateFilter);
                } else if (type === "episode") {
                  //  VODと見逃しのみ表示
                  favoriteMetas = favoriteMetas.filter(function (meta) {
                    var _meta$values7, _meta$values8, _meta$values9;

                    if (!(meta !== null && meta !== void 0 && (_meta$values7 = meta.values) !== null && _meta$values7 !== void 0 && _meta$values7.is_live)) return true;
                    var ended = isEnded(meta === null || meta === void 0 ? void 0 : (_meta$values8 = meta.values) === null || _meta$values8 === void 0 ? void 0 : _meta$values8.encode_end_date);
                    return (meta === null || meta === void 0 ? void 0 : (_meta$values9 = meta.values) === null || _meta$values9 === void 0 ? void 0 : _meta$values9.catch_up_flag) && ended;
                  }).filter(deliveryDateFilter);
                }

                favoriteMetas = favoriteMetas.filter(function (meta) {
                  var rating = req.userToken.rating;
                  var permitRating = userRating[rating].permitRating;
                  return permitRating.includes(meta.values.rating);
                });
                totalCount = favoriteMetas.length;
                favoriteMetas = favoriteMetas.slice(offset, offset + limit);
                return _context3.abrupt("return", {
                  data: favoriteMetas,
                  pageInfo: createPageInfo({
                    limit: limit,
                    offset: offset,
                    count: totalCount
                  })
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function favoritesByContentType(_x12, _x13, _x14) {
        return _favoritesByContentType.apply(this, arguments);
      }

      return favoritesByContentType;
    }(),
    viewingHistories: function () {
      var _viewingHistories = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_parent, _ref4, _ref5) {
        var offset, limit, sort, nocache, dataSources, res, metas;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                offset = _ref4.offset, limit = _ref4.limit, sort = _ref4.sort, nocache = _ref4.nocache;
                dataSources = _ref5.dataSources;
                _context4.prev = 2;
                _context4.next = 5;
                return dataSources.user.getViewingHistory({
                  offset: offset,
                  limit: limit,
                  sort: sort,
                  nocache: nocache
                });

              case 5:
                res = _context4.sent;
                metas = res.viewing_histories.map(function (vh) {
                  return _objectSpread(_objectSpread({}, vh.meta), {}, {
                    resume_point: vh.resume_point,
                    last_viewing_at: vh.last_viewing_at
                  });
                });
                return _context4.abrupt("return", {
                  data: metas,
                  pageInfo: createPageInfo({
                    limit: limit,
                    offset: offset,
                    count: res.total_count
                  })
                });

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](2);
                console.log("getViewingHistory error", _context4.t0);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 10]]);
      }));

      function viewingHistories(_x15, _x16, _x17) {
        return _viewingHistories.apply(this, arguments);
      }

      return viewingHistories;
    }(),
    broadcastDiscount: function () {
      var _broadcastDiscount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_parent, args, _ref6) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dataSources = _ref6.dataSources;
                _context5.prev = 1;
                _context5.next = 4;
                return dataSources.user.broadcastDiscount(args);

              case 4:
                res = _context5.sent;
                console.log("broadcastDiscount", res);
                return _context5.abrupt("return", res);

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](1);
                console.log("delete broadcastDiscount error", _context5.t0);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 9]]);
      }));

      function broadcastDiscount(_x18, _x19, _x20) {
        return _broadcastDiscount.apply(this, arguments);
      }

      return broadcastDiscount;
    }()
  },
  Mutation: {
    // ログイン
    // remembermeの仕様はデザイン上ないが後から言われる可能性があるので機能としては残しておく
    login: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_parent, _ref7, _ref8) {
        var loginid, password, rememberme, signature, req, res, dataSources, user, token, uid2, _rememberme, _e$extensions, _e$extensions$respons, _response$error, response;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                loginid = _ref7.loginid, password = _ref7.password, rememberme = _ref7.rememberme, signature = _ref7.signature;
                req = _ref8.req, res = _ref8.res, dataSources = _ref8.dataSources;
                _context6.prev = 2;
                _context6.next = 5;
                return dataSources.user.login(loginid, password);

              case 5:
                user = _context6.sent;
                _context6.next = 8;
                return createToken(req, res, user, signature, rememberme);

              case 8:
                token = _context6.sent;
                uid2 = new Uid2Token(req, res);
                _context6.next = 12;
                return uid2.getToken();

              case 12:
                if (rememberme) {
                  _rememberme = new Rememberme();

                  _rememberme.save(user.id, {
                    loginid: loginid,
                    password: password
                  });
                }

                return _context6.abrupt("return", {
                  token: token,
                  user: user.user
                });

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6["catch"](2);
                console.log("login auth error", _context6.t0); // console.log(JSON.stringify(e.extentions, null, 2));

                response = _context6.t0 === null || _context6.t0 === void 0 ? void 0 : (_e$extensions = _context6.t0.extensions) === null || _e$extensions === void 0 ? void 0 : (_e$extensions$respons = _e$extensions.response) === null || _e$extensions$respons === void 0 ? void 0 : _e$extensions$respons.body;

                if (!(response && (response === null || response === void 0 ? void 0 : (_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.code) == 10006)) {
                  _context6.next = 24;
                  break;
                }

                throw new UserInputError(AUTH_ERROR_MESSAGES["acountlock"]);

              case 24:
                throw new UserInputError(AUTH_ERROR_MESSAGES["unauthorized"]);

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 16]]);
      }));

      function login(_x21, _x22, _x23) {
        return _login.apply(this, arguments);
      }

      return login;
    }(),
    // ログアウト
    logout: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_parent, _ref9, _ref10) {
        var force, req, res, dataSources, _yield$dataSources$us, result, errorCode;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                force = _ref9.force;
                req = _ref10.req, res = _ref10.res, dataSources = _ref10.dataSources;
                _context7.prev = 2;
                _context7.next = 5;
                return dataSources.user.logout();

              case 5:
                _yield$dataSources$us = _context7.sent;
                result = _yield$dataSources$us.result;

                if (!result) {
                  _context7.next = 10;
                  break;
                }

                _context7.next = 10;
                return deleteToken(req, res);

              case 10:
                return _context7.abrupt("return", {
                  result: result
                });

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7["catch"](2);
                errorCode = logicaErrorCode(_context7.t0);
                console.log("logout error errorCode: ".concat(errorCode));
                return _context7.abrupt("return", {
                  result: false
                });

              case 18:
                _context7.prev = 18;

                if (!force) {
                  _context7.next = 22;
                  break;
                }

                _context7.next = 22;
                return deleteToken(req, res);

              case 22:
                return _context7.finish(18);

              case 23:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[2, 13, 18, 23]]);
      }));

      function logout(_x24, _x25, _x26) {
        return _logout.apply(this, arguments);
      }

      return logout;
    }(),
    // プロフィールを選択
    selectProfile: function () {
      var _selectProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(parent, args, _ref11) {
        var req, res, dataSources, userToken, token, _res, profiles, user, _selectProfile2, _selectProfile2$value, _selectProfile2$value2, _selectProfile2$value3;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                req = _ref11.req, res = _ref11.res, dataSources = _ref11.dataSources;
                // args : profileId, passcode, type
                // type : auth, no-auth
                userToken = new UserToken(req, res);
                _context8.next = 4;
                return userToken.verify();

              case 4:
                token = _context8.sent;

                if (!token) {
                  _context8.next = 22;
                  break;
                }

                _context8.next = 8;
                return dataSources.user.me();

              case 8:
                _res = _context8.sent;
                _context8.next = 11;
                return getProfiles(parent, dataSources, req.adultMode);

              case 11:
                profiles = _context8.sent;
                user = _res.user;
                _selectProfile2 = profiles.find(function (profile) {
                  return profile.id == args.profileId;
                });

                if (!_selectProfile2) {
                  _context8.next = 22;
                  break;
                }

                if (!(args.type == "auth" && (_selectProfile2$value = _selectProfile2.values) !== null && _selectProfile2$value !== void 0 && _selectProfile2$value.passcode && ((_selectProfile2$value2 = _selectProfile2.values) === null || _selectProfile2$value2 === void 0 ? void 0 : _selectProfile2$value2.passcode) != args.passcode)) {
                  _context8.next = 17;
                  break;
                }

                throw new UserInputError(AUTH_ERROR_MESSAGES["invalidPasscode"]);

              case 17:
                user.profiles = profiles;
                user.selectProfileId = args.profileId;
                _context8.next = 21;
                return userToken.refresh({
                  currentProfile: args.profileId,
                  rating: (_selectProfile2$value3 = _selectProfile2.values) === null || _selectProfile2$value3 === void 0 ? void 0 : _selectProfile2$value3.rating
                });

              case 21:
                return _context8.abrupt("return", user);

              case 22:
                return _context8.abrupt("return", null);

              case 23:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function selectProfile(_x27, _x28, _x29) {
        return _selectProfile.apply(this, arguments);
      }

      return selectProfile;
    }(),
    // 会員登録時のPINコード送信
    signupPincode: function () {
      var _signupPincode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_parent, _ref12, _ref13) {
        var mailAddress, req, res, dataSources, user, pinCode, pin;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                mailAddress = _ref12.mailAddress;
                req = _ref13.req, res = _ref13.res, dataSources = _ref13.dataSources;
                _context9.prev = 2;
                _context9.next = 5;
                return dataSources.user.existed(mailAddress);

              case 5:
                user = _context9.sent;

                if (!user) {
                  _context9.next = 11;
                  break;
                }

                _context9.next = 9;
                return sendEmail(duplicateAddress({
                  address: mailAddress
                }, req.adultMode));

              case 9:
                _context9.next = 17;
                break;

              case 11:
                pinCode = new PINCode(req, res);
                _context9.next = 14;
                return pinCode.publish(mailAddress);

              case 14:
                pin = _context9.sent;
                _context9.next = 17;
                return sendEmail(registerPincodeMail({
                  address: mailAddress,
                  pincode: pin
                }, req.adultMode));

              case 17:
                return _context9.abrupt("return", {
                  result: true
                });

              case 20:
                _context9.prev = 20;
                _context9.t0 = _context9["catch"](2);
                console.log("pincode send error", _context9.t0);
                throw new UserInputError(AUTH_ERROR_MESSAGES["default"]);

              case 24:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[2, 20]]);
      }));

      function signupPincode(_x30, _x31, _x32) {
        return _signupPincode.apply(this, arguments);
      }

      return signupPincode;
    }(),
    // メールアドレス変更PINコード送信
    sendPincode: function () {
      var _sendPincode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_parent, _ref14, _ref15) {
        var mailAddress, req, res, dataSources, user, pinCode, pin;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                mailAddress = _ref14.mailAddress;
                req = _ref15.req, res = _ref15.res, dataSources = _ref15.dataSources;
                _context10.next = 4;
                return dataSources.user.existed(mailAddress);

              case 4:
                user = _context10.sent;

                if (!user) {
                  _context10.next = 11;
                  break;
                }

                _context10.next = 8;
                return sendEmail(accountEditDuplicateAddress({
                  address: mailAddress
                }, req.adultMode));

              case 8:
                return _context10.abrupt("return", {
                  result: false
                });

              case 11:
                pinCode = new PINCode(req, res);
                _context10.next = 14;
                return pinCode.publish(mailAddress);

              case 14:
                pin = _context10.sent;
                _context10.next = 17;
                return sendEmail(accountEditPincodeMail({
                  address: mailAddress,
                  pincode: pin
                }, req.adultMode));

              case 17:
                return _context10.abrupt("return", {
                  result: true
                });

              case 18:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function sendPincode(_x33, _x34, _x35) {
        return _sendPincode.apply(this, arguments);
      }

      return sendPincode;
    }(),
    // プロフィール暗証番号リセットURLの送信
    sendProfilePinResetToken: function () {
      var _sendProfilePinResetToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_parent, _args, _ref16) {
        var req, res, dataSources, _yield$dataSources$us2, user, mailAddress, passwordToken, token;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                req = _ref16.req, res = _ref16.res, dataSources = _ref16.dataSources;
                _context11.next = 3;
                return dataSources.user.me();

              case 3:
                _yield$dataSources$us2 = _context11.sent;
                user = _yield$dataSources$us2.user;
                mailAddress = user.mail_address;
                passwordToken = new PasswordToken(req, res);
                _context11.next = 9;
                return passwordToken.publish(mailAddress);

              case 9:
                token = _context11.sent;
                _context11.next = 12;
                return sendEmail(profilePinResetTokenMail({
                  address: mailAddress,
                  token: token
                }, req.adultMode));

              case 12:
                return _context11.abrupt("return", {
                  result: true
                });

              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function sendProfilePinResetToken(_x36, _x37, _x38) {
        return _sendProfilePinResetToken.apply(this, arguments);
      }

      return sendProfilePinResetToken;
    }(),
    // パスワードリセットメールの送信
    sendPasswordResetToken: function () {
      var _sendPasswordResetToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_parent, _ref17, _ref18) {
        var mailAddress, req, res, dataSources, user, passwordToken, token;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                mailAddress = _ref17.mailAddress;
                req = _ref18.req, res = _ref18.res, dataSources = _ref18.dataSources;
                _context12.next = 4;
                return dataSources.user.existed(mailAddress);

              case 4:
                user = _context12.sent;

                if (!user) {
                  _context12.next = 12;
                  break;
                }

                // ユーザーが存在していたらTokenメールを送る
                passwordToken = new PasswordToken(req, res);
                _context12.next = 9;
                return passwordToken.publish(mailAddress);

              case 9:
                token = _context12.sent;
                _context12.next = 12;
                return sendEmail(passwordResetTokenMail({
                  address: mailAddress,
                  token: token
                }, req.adultMode));

              case 12:
                return _context12.abrupt("return", {
                  result: true
                });

              case 13:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function sendPasswordResetToken(_x39, _x40, _x41) {
        return _sendPasswordResetToken.apply(this, arguments);
      }

      return sendPasswordResetToken;
    }(),
    // PINコード検証
    verifyPinCode: function () {
      var _verifyPinCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_parent, args, _ref19) {
        var req, res, pinCode, verified;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                req = _ref19.req, res = _ref19.res;
                pinCode = new PINCode(req, res);
                _context13.next = 4;
                return pinCode.verify(args.code, args.mailAddress);

              case 4:
                verified = _context13.sent;

                if (verified) {
                  _context13.next = 7;
                  break;
                }

                throw new UserInputError(AUTH_ERROR_MESSAGES["pincode"], {
                  invalidArgs: Object.keys(args)
                });

              case 7:
                return _context13.abrupt("return", {
                  verified: verified
                });

              case 8:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function verifyPinCode(_x42, _x43, _x44) {
        return _verifyPinCode.apply(this, arguments);
      }

      return verifyPinCode;
    }(),
    // passwordToken検証
    verifyPasswordToken: function () {
      var _verifyPasswordToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_parent, _ref20, _ref21) {
        var token, req, res, passwordToken, verified;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                token = _ref20.token;
                req = _ref21.req, res = _ref21.res;
                passwordToken = new PasswordToken(req, res);
                _context14.next = 5;
                return passwordToken.verify(token);

              case 5:
                verified = _context14.sent;

                if (!verified) {
                  console.log("verifyPasswordToken error", AUTH_ERROR_MESSAGES["passwordToken"]); // } else {
                  //   await passwordToken.delete(token);
                }

                return _context14.abrupt("return", {
                  verified: verified
                });

              case 8:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function verifyPasswordToken(_x45, _x46, _x47) {
        return _verifyPasswordToken.apply(this, arguments);
      }

      return verifyPasswordToken;
    }(),
    // サインアップ
    signup: function () {
      var _signup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_parent, args, _ref22) {
        var req, res, dataSources, pinCode, verified, existsUser, ua, clientIp, user, token, agreeTerms, uid2;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                req = _ref22.req, res = _ref22.res, dataSources = _ref22.dataSources;
                _context16.prev = 1;
                console.log("############### signup mutation start ###############"); // パスワードバリデート

                if (passwordValidate(args.password)) {
                  _context16.next = 5;
                  break;
                }

                throw new UserInputError(errorMessages["badPassword"], {
                  invalidArgs: ["password"]
                });

              case 5:
                // ここでもメールアドレスが認証済みかの確認をする
                pinCode = new PINCode(req, res);
                _context16.next = 8;
                return pinCode.verify(args.code, args.mailAddress);

              case 8:
                verified = _context16.sent;

                if (verified) {
                  _context16.next = 11;
                  break;
                }

                throw new UserInputError(AUTH_ERROR_MESSAGES["pincode"], {
                  invalidArgs: Object.keys(args)
                });

              case 11:
                _context16.next = 13;
                return dataSources.user.existed(args.mailAddress);

              case 13:
                existsUser = _context16.sent;

                if (!existsUser) {
                  _context16.next = 16;
                  break;
                }

                throw new UserInputError(AUTH_ERROR_MESSAGES["signup"]);

              case 16:
                ua = req.headers["user-agent"];
                clientIp = getRemoteIpAddress(req);
                console.log("ua: ", ua);
                console.log("ip: ", clientIp);
                console.log("signup api request");
                _context16.next = 23;
                return dataSources.user.signup(args);

              case 23:
                user = _context16.sent;

                if (user) {
                  console.log("user registered");
                  console.log("userId: ", user.id);
                }

                pinCode.delete(args.mailAddress);
                _context16.next = 28;
                return createToken(req, res, user, args.signature, false);

              case 28:
                token = _context16.sent;
                console.log("agreedterms: ", args.terms); // 規約の同意

                agreeTerms = args.terms.split(",");
                _context16.next = 33;
                return Promise.all(agreeTerms.map( /*#__PURE__*/function () {
                  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(key) {
                    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                      while (1) {
                        switch (_context15.prev = _context15.next) {
                          case 0:
                            _context15.next = 2;
                            return dataSources.terms.agree(key);

                          case 2:
                            return _context15.abrupt("return", _context15.sent);

                          case 3:
                          case "end":
                            return _context15.stop();
                        }
                      }
                    }, _callee15);
                  }));

                  return function (_x51) {
                    return _ref23.apply(this, arguments);
                  };
                }()));

              case 33:
                _context16.next = 35;
                return sendEmail(signupComplete({
                  address: args.mailAddress,
                  user: user.user
                }, req.adultMode));

              case 35:
                uid2 = new Uid2Token(req, res);
                _context16.next = 38;
                return uid2.getToken();

              case 38:
                console.log("############### signup mutation end ###############");
                return _context16.abrupt("return", {
                  token: token,
                  user: user.user
                });

              case 42:
                _context16.prev = 42;
                _context16.t0 = _context16["catch"](1);
                console.log("signup error", _context16.t0);

                if (!(_context16.t0 instanceof UserInputError)) {
                  _context16.next = 49;
                  break;
                }

                throw _context16.t0;

              case 49:
                throw new UserInputError(AUTH_ERROR_MESSAGES["signup"]);

              case 50:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, null, [[1, 42]]);
      }));

      function signup(_x48, _x49, _x50) {
        return _signup.apply(this, arguments);
      }

      return signup;
    }(),
    // お気に入り追加
    addFavorite: function () {
      var _addFavorite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_parent, _ref24, _ref25) {
        var id, req, dataSources, _yield$dataSources$us3, result, favoriteMetas, userId;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                id = _ref24.id;
                req = _ref25.req, dataSources = _ref25.dataSources;
                _context17.next = 4;
                return dataSources.user.addFavorite(id);

              case 4:
                _yield$dataSources$us3 = _context17.sent;
                result = _yield$dataSources$us3.result;
                _context17.next = 8;
                return sleep(200);

              case 8:
                _context17.next = 10;
                return getFavoriteMetas(dataSources);

              case 10:
                favoriteMetas = _context17.sent;
                userId = req.userToken.currentProfile || req.userToken.id;
                return _context17.abrupt("return", {
                  result: result,
                  favorites: {
                    id: userId,
                    metas: favoriteMetas
                  }
                });

              case 13:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function addFavorite(_x52, _x53, _x54) {
        return _addFavorite.apply(this, arguments);
      }

      return addFavorite;
    }(),
    // お気に入り削除
    deleteFavorite: function () {
      var _deleteFavorite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_parent, _ref26, _ref27) {
        var id, req, dataSources, _yield$dataSources$us4, result, favoriteMetas, userId;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                id = _ref26.id;
                req = _ref27.req, dataSources = _ref27.dataSources;
                _context18.next = 4;
                return dataSources.user.deleteFavorite(id);

              case 4:
                _yield$dataSources$us4 = _context18.sent;
                result = _yield$dataSources$us4.result;
                _context18.next = 8;
                return sleep(200);

              case 8:
                _context18.next = 10;
                return getFavoriteMetas(dataSources);

              case 10:
                favoriteMetas = _context18.sent;
                userId = req.userToken.currentProfile || req.userToken.id;
                return _context18.abrupt("return", {
                  result: result,
                  favorites: {
                    id: userId,
                    metas: favoriteMetas
                  }
                });

              case 13:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function deleteFavorite(_x55, _x56, _x57) {
        return _deleteFavorite.apply(this, arguments);
      }

      return deleteFavorite;
    }(),
    // 視聴履歴、ブックマーク追加
    addResume: function () {
      var _addResume = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(_parent, args, _ref28) {
        var dataSources;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                dataSources = _ref28.dataSources;
                _context19.prev = 1;
                _context19.next = 4;
                return dataSources.user.addViewingHistory(args);

              case 4:
                _context19.next = 6;
                return dataSources.user.addViewingBookmark(args);

              case 6:
                return _context19.abrupt("return", {
                  result: true
                });

              case 9:
                _context19.prev = 9;
                _context19.t0 = _context19["catch"](1);
                console.log("addResume error", JSON.stringify(_context19.t0, null, 2));
                return _context19.abrupt("return", {
                  result: false
                });

              case 13:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, null, [[1, 9]]);
      }));

      function addResume(_x58, _x59, _x60) {
        return _addResume.apply(this, arguments);
      }

      return addResume;
    }(),
    update: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(_parent, _ref29, _ref30) {
        var mailAddress, code, req, res, dataSources, _user$user, pinCode, verified, user;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                mailAddress = _ref29.mailAddress, code = _ref29.code;
                req = _ref30.req, res = _ref30.res, dataSources = _ref30.dataSources;
                _context20.prev = 2;
                // メールアドレスが認証済みかの確認をする
                pinCode = new PINCode(req, res);
                _context20.next = 6;
                return pinCode.verify(code, mailAddress);

              case 6:
                verified = _context20.sent;

                if (verified) {
                  _context20.next = 9;
                  break;
                }

                throw new UserInputError(errorMessages["pincode"], {
                  invalidArgs: Object.keys({
                    mailAddress: mailAddress,
                    code: code
                  })
                });

              case 9:
                _context20.next = 11;
                return dataSources.user.update({
                  mailAddress: mailAddress
                });

              case 11:
                user = _context20.sent;
                pinCode.delete(mailAddress);
                _context20.next = 15;
                return sendEmail(userUpdate({
                  address: user === null || user === void 0 ? void 0 : (_user$user = user.user) === null || _user$user === void 0 ? void 0 : _user$user.mail_address,
                  user: user.user
                }, req === null || req === void 0 ? void 0 : req.adultMode));

              case 15:
                return _context20.abrupt("return", {
                  user: user.user
                });

              case 18:
                _context20.prev = 18;
                _context20.t0 = _context20["catch"](2);
                console.log("update error", _context20.t0);

                if (!(_context20.t0 instanceof UserInputError)) {
                  _context20.next = 25;
                  break;
                }

                throw _context20.t0;

              case 25:
                throw new UserInputError(errorMessages["update"]);

              case 26:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, null, [[2, 18]]);
      }));

      function update(_x61, _x62, _x63) {
        return _update.apply(this, arguments);
      }

      return update;
    }(),
    updatePassword: function () {
      var _updatePassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_parent, _ref31, _ref32) {
        var currentPassword, password, req, dataSources, check, _user$user2, user, mailAddress;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                currentPassword = _ref31.currentPassword, password = _ref31.password;
                req = _ref32.req, dataSources = _ref32.dataSources;
                _context21.prev = 2;
                _context21.next = 5;
                return dataSources.user.checkPassword(currentPassword);

              case 5:
                check = _context21.sent;

                if (!check.result) {
                  _context21.next = 18;
                  break;
                }

                if (passwordValidate(password)) {
                  _context21.next = 9;
                  break;
                }

                throw new UserInputError(errorMessages["badPassword"], {
                  invalidArgs: ["password"]
                });

              case 9:
                _context21.next = 11;
                return dataSources.user.updatePassword(password);

              case 11:
                user = _context21.sent;
                mailAddress = user === null || user === void 0 ? void 0 : (_user$user2 = user.user) === null || _user$user2 === void 0 ? void 0 : _user$user2.mail_address;
                _context21.next = 15;
                return sendEmail(passwordUpdateComplete({
                  address: mailAddress
                }, req.adultMode));

              case 15:
                return _context21.abrupt("return", {
                  user: user.user
                });

              case 18:
                throw new UserInputError(errorMessages["invalidPassword"]);

              case 19:
                _context21.next = 29;
                break;

              case 21:
                _context21.prev = 21;
                _context21.t0 = _context21["catch"](2);
                console.log("update password error", _context21.t0);

                if (!(_context21.t0 instanceof UserInputError)) {
                  _context21.next = 28;
                  break;
                }

                throw _context21.t0;

              case 28:
                throw new UserInputError(errorMessages["updatePassword"]);

              case 29:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, null, [[2, 21]]);
      }));

      function updatePassword(_x64, _x65, _x66) {
        return _updatePassword.apply(this, arguments);
      }

      return updatePassword;
    }(),
    passwordReset: function () {
      var _passwordReset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_parent, _ref33, _ref34) {
        var token, password, req, res, dataSources, passwordToken, mailAddress, user, id, result, _e$extensions2;

        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                token = _ref33.token, password = _ref33.password;
                req = _ref34.req, res = _ref34.res, dataSources = _ref34.dataSources;
                _context22.prev = 2;
                passwordToken = new PasswordToken(req, res);
                _context22.next = 6;
                return passwordToken.getValue(token);

              case 6:
                mailAddress = _context22.sent;
                _context22.next = 9;
                return dataSources.user.existed(mailAddress);

              case 9:
                user = _context22.sent;
                id = user === null || user === void 0 ? void 0 : user.id;
                _context22.next = 13;
                return dataSources.user.passwordUpdate({
                  userId: id,
                  password: password
                });

              case 13:
                result = _context22.sent;
                _context22.next = 16;
                return passwordToken.delete(token);

              case 16:
                if (!result) {
                  _context22.next = 22;
                  break;
                }

                _context22.next = 19;
                return sendEmail(passwordResetComplete({
                  address: mailAddress
                }, req.adultMode));

              case 19:
                return _context22.abrupt("return", {
                  result: true
                });

              case 22:
                return _context22.abrupt("return", {
                  result: false
                });

              case 23:
                _context22.next = 30;
                break;

              case 25:
                _context22.prev = 25;
                _context22.t0 = _context22["catch"](2);
                console.log("password reset error", _context22.t0);

                if (_context22.t0 !== null && _context22.t0 !== void 0 && (_e$extensions2 = _context22.t0.extensions) !== null && _e$extensions2 !== void 0 && _e$extensions2.response) {
                  console.dir(_context22.t0.extensions.response);
                }

                throw new UserInputError(errorMessages["passwordReset"]);

              case 30:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, null, [[2, 25]]);
      }));

      function passwordReset(_x67, _x68, _x69) {
        return _passwordReset.apply(this, arguments);
      }

      return passwordReset;
    }(),
    passcodeReset: function () {
      var _passcodeReset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(_parent, _ref35, _ref36) {
        var token, passcode, req, res, dataSources, passwordToken, mailAddress, _yield$dataSources$us5, user, userToken;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                token = _ref35.token, passcode = _ref35.passcode;
                req = _ref36.req, res = _ref36.res, dataSources = _ref36.dataSources;
                _context23.prev = 2;

                if (!(passcode && !/^\d{4}$/.test(passcode))) {
                  _context23.next = 5;
                  break;
                }

                throw new UserInputError(errorMessages["passcodeReset"]);

              case 5:
                passwordToken = new PasswordToken(req, res);
                _context23.next = 8;
                return passwordToken.getValue(token);

              case 8:
                mailAddress = _context23.sent;
                _context23.next = 11;
                return dataSources.user.me();

              case 11:
                _yield$dataSources$us5 = _context23.sent;
                user = _yield$dataSources$us5.user;
                _context23.next = 15;
                return passwordToken.delete(token);

              case 15:
                if (!(user.mail_address === mailAddress)) {
                  _context23.next = 24;
                  break;
                }

                _context23.next = 18;
                return dataSources.user.updateOwnerProfile({
                  passcode: passcode
                });

              case 18:
                userToken = new UserToken(req, res);
                _context23.next = 21;
                return userToken.refresh();

              case 21:
                return _context23.abrupt("return", {
                  result: true
                });

              case 24:
                console.log("update passcode reset mailAddress unmatched.");
                throw new Error("mailAddress unmatched.");

              case 26:
                _context23.next = 32;
                break;

              case 28:
                _context23.prev = 28;
                _context23.t0 = _context23["catch"](2);
                console.log("update owner passcode reset error", _context23.t0);
                throw new UserInputError(errorMessages["passcodeReset"]);

              case 32:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, null, [[2, 28]]);
      }));

      function passcodeReset(_x70, _x71, _x72) {
        return _passcodeReset.apply(this, arguments);
      }

      return passcodeReset;
    }(),
    updateOwnerProfile: function () {
      var _updateOwnerProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(_parent, args, _ref37) {
        var req, res, dataSources, user, userToken;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                req = _ref37.req, res = _ref37.res, dataSources = _ref37.dataSources;
                _context24.prev = 1;

                if (!(args.passcode && !/^\d{4}$/.test(args.passcode))) {
                  _context24.next = 4;
                  break;
                }

                throw new UserInputError(errorMessages["profileUpdate"]);

              case 4:
                _context24.next = 6;
                return dataSources.user.updateOwnerProfile(args);

              case 6:
                user = _context24.sent;
                userToken = new UserToken(req, res);
                _context24.next = 10;
                return userToken.refresh({
                  rating: args.rating
                });

              case 10:
                return _context24.abrupt("return", {
                  user: user.user
                });

              case 13:
                _context24.prev = 13;
                _context24.t0 = _context24["catch"](1);
                console.log("update owner profile error", _context24.t0);
                throw new UserInputError(errorMessages["profileUpdate"]);

              case 17:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, null, [[1, 13]]);
      }));

      function updateOwnerProfile(_x73, _x74, _x75) {
        return _updateOwnerProfile.apply(this, arguments);
      }

      return updateOwnerProfile;
    }(),
    addProfile: function () {
      var _addProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(_parent, args, _ref38) {
        var dataSources, _result$profile, result;

        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                dataSources = _ref38.dataSources;
                _context25.prev = 1;

                if (!(args.passcode && !/^\d{4}$/.test(args.passcode))) {
                  _context25.next = 4;
                  break;
                }

                throw new UserInputError(errorMessages["profileUpdate"]);

              case 4:
                _context25.next = 6;
                return dataSources.user.addProfile(args);

              case 6:
                result = _context25.sent;

                // 暫定対応: profiles系のAPIの時だけActiveRecord::Modelがそのままjsonになっているため
                // 性別が文字列で返ってきてしまう
                if (typeof (result === null || result === void 0 ? void 0 : (_result$profile = result.profile) === null || _result$profile === void 0 ? void 0 : _result$profile.sex) === "string") {
                  result.profile.sex = GENDER[result.profile.sex];
                }

                return _context25.abrupt("return", {
                  profile: result.profile
                });

              case 11:
                _context25.prev = 11;
                _context25.t0 = _context25["catch"](1);
                console.log("add profile error", _context25.t0);
                throw new UserInputError(errorMessages["profile"]);

              case 15:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, null, [[1, 11]]);
      }));

      function addProfile(_x76, _x77, _x78) {
        return _addProfile.apply(this, arguments);
      }

      return addProfile;
    }(),
    updateProfile: function () {
      var _updateProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(_parent, args, _ref39) {
        var dataSources, _result$profile2, result;

        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                dataSources = _ref39.dataSources;
                _context26.prev = 1;

                if (!(args.passcode && !/^\d{4}$/.test(args.passcode))) {
                  _context26.next = 4;
                  break;
                }

                throw new UserInputError(errorMessages["profileUpdate"]);

              case 4:
                _context26.next = 6;
                return dataSources.user.updateProfile(args);

              case 6:
                result = _context26.sent;

                // 暫定対応: profiles系のAPIの時だけActiveRecord::Modelがそのままjsonになっているため
                // 性別が文字列で返ってきてしまう
                if (typeof (result === null || result === void 0 ? void 0 : (_result$profile2 = result.profile) === null || _result$profile2 === void 0 ? void 0 : _result$profile2.sex) === "string") {
                  result.profile.sex = GENDER[result.profile.sex];
                }

                return _context26.abrupt("return", {
                  profile: result.profile
                });

              case 11:
                _context26.prev = 11;
                _context26.t0 = _context26["catch"](1);
                console.log("update profile error", _context26.t0);
                throw new UserInputError(errorMessages["profileUpdate"]);

              case 15:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, null, [[1, 11]]);
      }));

      function updateProfile(_x79, _x80, _x81) {
        return _updateProfile.apply(this, arguments);
      }

      return updateProfile;
    }(),
    deleteProfile: function () {
      var _deleteProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(_parent, args, _ref40) {
        var dataSources, profile;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                dataSources = _ref40.dataSources;
                _context27.prev = 1;
                _context27.next = 4;
                return dataSources.user.deleteProfile(args);

              case 4:
                profile = _context27.sent;
                return _context27.abrupt("return", profile);

              case 8:
                _context27.prev = 8;
                _context27.t0 = _context27["catch"](1);
                console.log("delete profile error", _context27.t0);
                throw new UserInputError(errorMessages["profileDelete"]);

              case 12:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, null, [[1, 8]]);
      }));

      function deleteProfile(_x82, _x83, _x84) {
        return _deleteProfile.apply(this, arguments);
      }

      return deleteProfile;
    }(),
    userDelete: function () {
      var _userDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(_parent, _args, _ref41) {
        var req, res, dataSources, _user$values, _yield$dataSources$us6, user, isMyskp, _yield$dataSources$us7, result, userToken;

        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                req = _ref41.req, res = _ref41.res, dataSources = _ref41.dataSources;
                _context28.prev = 1;
                _context28.next = 4;
                return dataSources.user.me();

              case 4:
                _yield$dataSources$us6 = _context28.sent;
                user = _yield$dataSources$us6.user;
                isMyskp = !!(user !== null && user !== void 0 && (_user$values = user.values) !== null && _user$values !== void 0 && _user$values.my_sptv_email);
                _context28.next = 9;
                return dataSources.user.withdrawal();

              case 9:
                _yield$dataSources$us7 = _context28.sent;
                result = _yield$dataSources$us7.result;
                userToken = new UserToken(req, res);
                _context28.next = 14;
                return userToken.deleteAll();

              case 14:
                req.userToken = null;

                if (!result) {
                  _context28.next = 23;
                  break;
                }

                if (!isMyskp) {
                  _context28.next = 21;
                  break;
                }

                _context28.next = 19;
                return sendEmail(myskpWithdrawalComplete({
                  address: user === null || user === void 0 ? void 0 : user.mail_address,
                  user: user
                }, req === null || req === void 0 ? void 0 : req.adultMode));

              case 19:
                _context28.next = 23;
                break;

              case 21:
                _context28.next = 23;
                return sendEmail(withdrawalComplete({
                  address: user === null || user === void 0 ? void 0 : user.mail_address,
                  user: user
                }, req === null || req === void 0 ? void 0 : req.adultMode));

              case 23:
                return _context28.abrupt("return", {
                  result: result
                });

              case 26:
                _context28.prev = 26;
                _context28.t0 = _context28["catch"](1);
                console.log("user delete error", _context28.t0);
                throw new UserInputError(errorMessages["userDelete"]);

              case 30:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, null, [[1, 26]]);
      }));

      function userDelete(_x85, _x86, _x87) {
        return _userDelete.apply(this, arguments);
      }

      return userDelete;
    }(),
    authProfile: function () {
      var _authProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(parent, args, _ref42) {
        var req, dataSources, _profile$values, profiles, profile, passcode;

        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                req = _ref42.req, dataSources = _ref42.dataSources;
                _context29.prev = 1;
                _context29.next = 4;
                return getProfiles(parent, dataSources, req.adultMode);

              case 4:
                profiles = _context29.sent;
                profile = profiles.find(function (profile) {
                  return profile.id == args.profileId;
                });
                passcode = profile === null || profile === void 0 ? void 0 : (_profile$values = profile.values) === null || _profile$values === void 0 ? void 0 : _profile$values.passcode;

                if (!(passcode == args.passcode)) {
                  _context29.next = 11;
                  break;
                }

                return _context29.abrupt("return", {
                  result: true
                });

              case 11:
                return _context29.abrupt("return", {
                  result: false
                });

              case 12:
                _context29.next = 17;
                break;

              case 14:
                _context29.prev = 14;
                _context29.t0 = _context29["catch"](1);
                console.log("authOwnerProfile error", _context29.t0);

              case 17:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, null, [[1, 14]]);
      }));

      function authProfile(_x88, _x89, _x90) {
        return _authProfile.apply(this, arguments);
      }

      return authProfile;
    }(),
    deleteViewingHistory: function () {
      var _deleteViewingHistory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(_parent, _ref43, _ref44) {
        var metaIds, dataSources, res;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                metaIds = _ref43.metaIds;
                dataSources = _ref44.dataSources;
                _context30.prev = 2;
                _context30.next = 5;
                return dataSources.user.deleteViewingHistory(metaIds.join(","));

              case 5:
                res = _context30.sent;
                _context30.next = 8;
                return sleep(200);

              case 8:
                return _context30.abrupt("return", res);

              case 11:
                _context30.prev = 11;
                _context30.t0 = _context30["catch"](2);
                console.log("delete ViewingHistory error", _context30.t0); // throw new UserInputError(errorMessages["deleteViewingHistory"]);

              case 14:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, null, [[2, 11]]);
      }));

      function deleteViewingHistory(_x91, _x92, _x93) {
        return _deleteViewingHistory.apply(this, arguments);
      }

      return deleteViewingHistory;
    }()
  },
  User: {
    __resolveType: function __resolveType(user) {
      switch (user.type) {
        case "account":
          return "AccountUser";

        case "profile":
          return "ProfileUser";
      }

      return "User";
    }
  },
  AccountUser: {
    fullName: function fullName(user) {
      return "".concat(user.last_name, " ").concat(user.first_name);
    },
    currentProfile: function () {
      var _currentProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(parent, _args, _ref45) {
        var _token$payload;

        var req, res, dataSources, userToken, token, profiles, profileId, profile;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                req = _ref45.req, res = _ref45.res, dataSources = _ref45.dataSources;
                userToken = new UserToken(req, res);
                _context31.next = 4;
                return userToken.verify();

              case 4:
                token = _context31.sent;

                if (!(token && (_token$payload = token.payload) !== null && _token$payload !== void 0 && _token$payload.currentProfile || parent.selectProfileId)) {
                  _context31.next = 12;
                  break;
                }

                _context31.next = 8;
                return getProfiles(parent, dataSources, req.adultMode);

              case 8:
                profiles = _context31.sent;
                profileId = token.payload.currentProfile || parent.selectProfileId;
                profile = profiles.find(function (profile) {
                  return profile.id == profileId;
                });
                return _context31.abrupt("return", profile);

              case 12:
                return _context31.abrupt("return", null);

              case 13:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31);
      }));

      function currentProfile(_x94, _x95, _x96) {
        return _currentProfile.apply(this, arguments);
      }

      return currentProfile;
    }(),
    profiles: function () {
      var _profiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(parent, _args, _ref46) {
        var req, dataSources, profiles;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                req = _ref46.req, dataSources = _ref46.dataSources;
                _context32.next = 3;
                return getProfiles(parent, dataSources, req.adultMode);

              case 3:
                profiles = _context32.sent;

                if (!profiles) {
                  _context32.next = 6;
                  break;
                }

                return _context32.abrupt("return", profiles.sort(function (a, b) {
                  return a.id - b.id;
                }));

              case 6:
                return _context32.abrupt("return", null);

              case 7:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));

      function profiles(_x97, _x98, _x99) {
        return _profiles.apply(this, arguments);
      }

      return profiles;
    }(),
    test_flg: function test_flg(user) {
      return values(user, "test_flg");
    },
    mySkpRelation: function mySkpRelation(user) {
      return !!values(user, "my_sptv_email");
    },
    mySkpEmail: function mySkpEmail(user) {
      return values(user, "my_sptv_email");
    },
    age: function age(user) {
      return calcAge(user.birthday);
    },
    hashedUserId: function hashedUserId(user) {
      return values(user, "user_id_hash");
    }
  },
  ProfileUser: {
    passcode: function passcode(profile) {
      return values(profile, "passcode");
    },
    ownerProfile: function ownerProfile(profile) {
      return (profile === null || profile === void 0 ? void 0 : profile.type) == "account" || false;
    },
    needPasscode: function needPasscode(profile) {
      return !!values(profile, "passcode");
    },
    icon: function icon(profile) {
      return values(profile, "icon");
    },
    rating: function rating(profile) {
      return values(profile, "rating");
    },
    age: function age(user) {
      return calcAge(user.birthday);
    }
  },
  FavoriteMeta: {
    __resolveType: metaResolveType
  }
}, {
  // "Mutation.logout": [isAuthenticated()],
  // "Query.userFavorites": [isAuthenticated()],
  "Query.favoritesByContentType": [isAuthenticated()],
  "Query.viewingHistories": [isAuthenticated()],
  "Mutation.selectProfile": [isAuthenticated()],
  "Mutation.addFavorite": [isAuthenticated()],
  "Mutation.deleteFavorite": [isAuthenticated()],
  "Mutation.updatePassword": [isAuthenticated(), ownerOnly()],
  "Mutation.updateOwnerProfile": [isAuthenticated(), ownerOnly()],
  "Mutation.addProfile": [isAuthenticated(), ownerOnly()],
  "Mutation.updateProfile": [isAuthenticated(), ownerOnly()],
  "Mutation.userDelete": [isAuthenticated(), ownerOnly()]
});